import React from "react";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { Additional } from "./Additional";
import WorkingCalenderSearchParams from "./WorkingCalenderSearchParams";
// Services
import { getWorkingCalenderTable } from "src/Requests/wrokingCalender";
// Utilities
import moment from "moment";
import * as R from "ramda";
// Types
import type {
  IWorkingCalenderSearchParams,
  IWorkingCalenderTableReport,
} from "src/Interfaces/workingCalender";

interface IProps {}

const WorkingCalender = ({}: IProps) => {
  const [searchParam, setSearchParam] =
    React.useState<IWorkingCalenderSearchParams>({
      from: moment().format("YYYY-MM-DD"),
      to: moment().add(7, "days").format("YYYY-MM-DD"),
    } as IWorkingCalenderSearchParams);
  const [serverSearchParams, setServerSearchParams] =
    React.useState<IWorkingCalenderSearchParams>({
      to: moment().format("YYYY-MM-DD"),
      from: moment().add(7, "days").format("YYYY-MM-DD"),
    } as IWorkingCalenderSearchParams);

  const handleSearch = () => {
    const cleanObject = R.pickBy(
      (v) => !(v === null || v === "" || (Array.isArray(v) && v.length === 0)),
      searchParam,
    );
    setServerSearchParams(cleanObject as IWorkingCalenderSearchParams);
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };
  return (
    <div className="flex flex-row items-start justify-center gap-3 w-full h-screen px-2 mt-5">
      <WorkingCalenderSearchParams
        searchParam={searchParam}
        searchParamChangeHandler={searchParamChangeHandler}
        onSubmit={handleSearch}
      />
      <div className="w-full !h-full">
        <TableTemplate<
          IWorkingCalenderSearchParams,
          IWorkingCalenderTableReport
        >
          getDataTable={getWorkingCalenderTable}
          TableUI={({ reports, onAction, setSortingType, sortingType }) => (
            <CommonTableUI
              reports={reports}
              sortingType={sortingType}
              setSortingType={setSortingType}
              tableBoxClassName="!mx-0"
              onAction={onAction}
              // AdditionalBody={Additional}
              // withSelect
            />
          )}
          withSort
          searchParameters={serverSearchParams}
        />
      </div>
    </div>
  );
};

export default WorkingCalender;
